module.exports = __webpack_public_path__ + "static/media/AnimationsBad.64f7f1ec.gif";